import Events from '@utilities/events'
import createElementFromString from '@utilities/dom-utils/create-element-from-string'
import Component from '@utilities/store/lib/component'
import store from '@utilities/store'
import moduleInit from '@utilities/module-init'
import '@utilities/scroll-to'

const JS_HOOK_ACCORDION = 'js-hook-accordion'
const JS_HOOK_RESULTS_COUNT = '[js-hook-store-locator-results-count]'
const JS_HOOK_SELECT_STORE = '[js-hook-select-store]'
const JS_HOOK_HOOK_STORE_ID_INPUT = '[js-hook-store-id-input]'
const JS_HOOK_RESULTS_TITLE ='[js-hook-results-title]'
const JS_HOOK_PAGE_FILTERS = '[js-hook-store-locator-page-filters]'
const NO_RESULTS_CLASS = 'store-locator__no-results'
const RESULTS_COUNT_HIDDEN = 'store-locator__result-title--hidden'
const HIDDEN_CLASS = 'u-hidden'

class StoreLocatorResults extends Component {
  constructor(element) {
    super({
      store,
      element,
    })

    this.noResultsMessage = this.element.dataset?.noResultsMessage || ''
    this.resultsTitle = document.querySelector(JS_HOOK_RESULTS_TITLE)
    this.pageFilters = document.querySelector(JS_HOOK_PAGE_FILTERS)

    this.setUI()

    // Events
    this.bindEvents()
  }

  setUI() {
    this.ui = {
      resultsCount: document.querySelector(JS_HOOK_RESULTS_COUNT),
      storeIdInput: document.querySelector(JS_HOOK_HOOK_STORE_ID_INPUT),
      storeSelectButtons: [...this.element.querySelectorAll(JS_HOOK_SELECT_STORE)],
    }
  }

  /**
   * Append the results html in the DOM
   * @param {String} html - html of the results
   */
  appendResults(html) {
    this.element.innerHTML = ''
    this.element.appendChild(html)

    moduleInit.async('[js-hook-accordion]', () =>
      import(/* webpackChunkName: "js/Accordion" */ '@components/accordion'),
    )
    Events.$trigger('events::dom-reinit')

    this.setUI()
    this.bindEvents()
  }

  /**
   * Get the results DOM element
   * @param {Array} results - the array of stores results
   * @returns {String} html of the results
   */
  getResults(results) {
    const resultsHtml = document.createElement('div')
    resultsHtml.setAttribute(JS_HOOK_ACCORDION, null)

    if (results.length > 0) {
      results.forEach((item) => {
        if (item.html) {
          const el = createElementFromString(item.html)
          resultsHtml.appendChild(el)

          const selectStoreButton = el.querySelector(JS_HOOK_SELECT_STORE)

          if (selectStoreButton) {
            selectStoreButton.addEventListener('click', () =>
              StoreLocatorResults.handleStoreSelectButtonClick(item),
            )
          }
        }
      })
      if(this.pageFilters) {
        this.pageFilters.classList.remove(HIDDEN_CLASS)
      }
    } else {
      resultsHtml.appendChild(
        createElementFromString(`<p class="${NO_RESULTS_CLASS}">${this.noResultsMessage}</p>`),
      )
      if(this.pageFilters) {
        this.pageFilters.classList.add(HIDDEN_CLASS)
      }
    }

    if (this.resultsTitle) {
      this.resultsTitle.classList.remove(RESULTS_COUNT_HIDDEN)
      this.resultsTitle.innerHTML = results.length
    }

    return resultsHtml
  }

  /**
   * render results on left side
   * @param {Array} results - the array of stores results
   */
  render(results) {
    const resultsList = this.getResults(results)

    this.appendResults(resultsList)
  }

  static isReady(state) {
    return state && state.mapsApiReady
  }

  stateChanged() {
    const { state, prevState } = store
    if (!StoreLocatorResults.isReady(state)) return
    // Render changes to results list
    const { stores } = state
    if (prevState.stores) {
      this.render(stores)
    }
  }

  openAccordion(id) {
    if (this.scrollTimeout) clearTimeout(this.scrollTimeout)
    Events.$trigger(`accordion::close`)
    Events.$trigger(`accordion[${id}]::open`)

    const targetElement = document.getElementById(id)

    this.scrollTimeout = setTimeout(() => {
      Events.$trigger('scroll-to::scroll', {
        data: {
          target: targetElement,
          scrollElement: this.element, // Optional, only needed when scrolling inside an element
          offset:
            this.element.getBoundingClientRect().top +
            targetElement.getBoundingClientRect().height / 2,
        },
      })
    }, 400)
  }

  static handleStoreSelectButtonClick(selectedStore) {
    Events.$trigger('shipping-form::setStore', { data: { store: selectedStore } })
    Events.$trigger('modal::close')
  }

  /**
   * Bind all general events
   */
  bindEvents() {
    Events.$on('store-locator::setActive', (_, { id }) => this.openAccordion(id))
    Events.$on('store-locator::setStore', (_, { selectedStore }) =>
      StoreLocatorResults.handleStoreSelectButtonClick(selectedStore),
    )
  }
}

export default StoreLocatorResults
